import { useReducer, useMemo } from 'react';
import { ConsumableItem } from 'api/consumablesApi';
import { ConsumableFilterStateParams, filterConsumableData } from './Utils';

const initialFilterState: ConsumableFilterStateParams = {
  filterSectionOpen: false,
  branchIds: [],
  itemNames: [],
  filterClient: [],
  unitType: [],
};

export type FilterAction =
  | { type: 'SET_FIELD'; field: keyof ConsumableFilterStateParams; value: any }
  | { type: 'RESET' }
  | { type: 'TOGGLE_SECTION' };

function filterReducer(
  state: ConsumableFilterStateParams,
  action: FilterAction
): ConsumableFilterStateParams {
  switch (action.type) {
    case 'SET_FIELD':
      return { ...state, [action.field]: action.value };

    case 'RESET':
      return { ...initialFilterState, filterSectionOpen: true };

    case 'TOGGLE_SECTION':
      return {
        ...state,
        filterSectionOpen: !state.filterSectionOpen,
      };

    default:
      return state;
  }
}

export const useConsumableFilters = (
  consumableData: ConsumableItem[] | undefined,
  setFilteredConsumableData: (data: ConsumableItem[]) => void
) => {
  const [state, dispatch] = useReducer(filterReducer, initialFilterState);

  const activeFilterCount = useMemo(() => {
    return (
      state.branchIds.length +
      state.filterClient.length +
      state.itemNames.length +
      state.unitType.length
    );
  }, [state]);

  const filteredResult = useMemo(() => {
    return filterConsumableData(consumableData || [], state);
  }, [consumableData, state]);

  const applyFilters = () => {
    setFilteredConsumableData(filteredResult);
    dispatch({ type: 'TOGGLE_SECTION' });
  };

  const resetFilters = () => {
    dispatch({ type: 'RESET' });
  };

  return {
    state,
    dispatch,
    activeFilterCount,
    filteredResult,
    applyFilters,
    resetFilters,
  };
};
